import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: ":courseId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "grade-map-course-details" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [],
});
